<svg xmlns="http://www.w3.org/2000/svg" width="14" height="17" viewBox="0 0 14 17">
    <g fill="none" fill-rule="evenodd" stroke="#000" stroke-linecap="square">
        <path d="M10.14 7.451v-4.57a1.882 1.882 0 1 0-3.763 0l-.001.27M3.688 14.286v1.613M10.139 14.286v1.613M1 8.987V10.6a2.15 2.15 0 0 0 2.15 2.15h7.527a2.15 2.15 0 0 0 2.15-2.15V8.987H1z"/>
    </g>
</svg>
